module.exports = __webpack_public_path__ + "static/media/vikki.159e446b.svg";